<template>

    <v-app>
        <div id="container">

            <v-row>

                <div  class="view authenticated-no-subscription">

                    <payment-form :dark-theme="true" :app-theme="true" :source="'android'" @completed="onLoadPaymentData"></payment-form>

                </div>

            </v-row>

        </div>
    </v-app>
</template>

<style>

    .hide {
        display: none;
    }

    .view {

        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 20px 23px;
    }

    .authenticated-no-subscription {

        padding: 60px 8px 0;
        overflow: hidden;

    }

    .authenticated-no-subscription #purchase-button {

        bottom: 30px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;

    }

    .authenticated-with-subscription #connect-button {

        bottom: 30px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;

    }

    .authenticated-with-subscription .time-block * {

        color: #fff;

    }

    .authenticated-no-subscription .no-subscription {

        position: absolute;
        top: 158px;
        left: 0;
        right: 0;
        margin: auto;
        width: 160px;
        padding: 3px;
        border-radius: 3px;
        border: 1px solid orange;
        color: orange;
        text-align: center;
        font-size: 14px;
    }

    .not-authenticated #purchase-button {

        width: 230px !important;
        position: relative;
        margin: 0 auto;

    }

    #container {

        background: #444;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;

    }


    [id^="paypal-overlay-"] { display:none!important;}

    .payment-button-container {
        width:90%!important;
    }


</style>

<script>
    // @ is an alias to /src

    import PaymentForm from '../components/paymentForm'
    
	export default {
        name: 'App Payment Form',

        components: {
            PaymentForm
		},
        methods: {
			
			async onLoadPaymentData (responseJSON) {

                switch(responseJSON.status) {
                    case 'AUTHENTICATED_WITH_SUBSCRIPTION':
                        this.haveSubscription = true;
                        this.currentPage = 'authenticated-with-subscription';
                        break;
                    case 'AUTHENTICATED_NO_SUBSCRIPTION':
                        this.haveSubscription = false;
                        this.currentPage = 'authenticated-no-subscription';
                        break;
                }
                this.onSubscriptionChange(this.haveSubscription);

			}

        }
    }
</script>
